import { createReducer, on } from '@ngrx/store';
import { listId } from './help-center-action';
import { initialHelpCenterState } from './help-center-state';

const _helpCenterReducer = createReducer(
  initialHelpCenterState,
  on(listId, (state: any, action) => {
    return {
      ...state,
      helpCenter: action.data,
    };
  })
);

export function helpCenterReducer(state: any, action: any) {
  return _helpCenterReducer(state, action);
}
